import { useCallback, useRef } from "react";
import { RequestHelper } from "../../../utils/requestHelper";
import { _ROUTES } from "../../../utils/_routes_constants";
import { _ACTIONS, _HTTP, _MESSAGES } from "../../../utils/constants";
import { createToast } from "../../../utils/toast";
import { isNaN } from "lodash";

/**
 *
 * @param {string} params.site
 * @param {string} params.fiscalYear
 * @param {string} params.version
 * @param {Function} setPendingRefresh - Function to set the pending refresh state.
 * @returns {Function} Callback function to handle cell value changes.
 */
export function useSalesOnCellValueChanged(params, setPendingRefresh) {
  const requestHelper = new RequestHelper();
  const pendingUpdatesRef = useRef(0);
  return useCallback(
    async (agParams) => {
      const { colDef, data, newValue } = agParams;
      const { site, fiscalYear, version } = params;
      const { group, rowName } = data;
      const field = colDef.field;

      pendingUpdatesRef.current++;

      if (!site || !fiscalYear || !version || !newValue || isNaN(newValue)) {
        createToast(
          "warning",
          "No site, value, fiscal or year available. Please check if you missed something.",
        );

        return;
      }

      let payload = {
        version: version,
        fiscalYear: fiscalYear,
        site: site,
        group: group,
        type: rowName,
        fiscalMonth: parseInt(field),
        value: newValue,
      };

      requestHelper
        .doRequest(_ACTIONS.POST, _ROUTES.SAVE_IPT_SF, payload)
        .then((response) => {
          if (!response.status === _HTTP.ok) {
            createToast("error", "Error saving data");
          }
        })
        .finally(() => {
          pendingUpdatesRef.current--;
          if (pendingUpdatesRef.current === 0) {
            createToast("success", _MESSAGES.data_sent);
            setPendingRefresh((p) => !p);
          }
        });
    },
    [params],
  );
}
